"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jquery_1 = __importDefault(require("jquery"));
window.$ = window.jQuery = jquery_1.default;
require("@fancyapps/fancybox/dist/jquery.fancybox");
const vue_property_decorator_1 = require("vue-property-decorator");
let InmuebleVideos = class InmuebleVideos extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.options = {};
    }
    mounted() {
        jquery_1.default(() => {
            jquery_1.default('.videoteca a[data-fancybox="videos"]').fancybox(this.options);
        });
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Array, required: true }),
    __metadata("design:type", Array)
], InmuebleVideos.prototype, "videos", void 0);
InmuebleVideos = __decorate([
    vue_property_decorator_1.Component({})
], InmuebleVideos);
exports.default = InmuebleVideos;
